<!-- src/app/components/mfalogin/mfalogin.html -->

<div class="auth-wrapper">
  <div class="auth-shade d-flex align-items-center justify-content-center">
    <div class="login-content p-4">
      <mat-card class="login-card" appearance="outlined">
        <mat-card-header class="login-header">
          <div class="logo-section mb-2">
            <img src="../../../assets/images/logo.svg" alt="BellaStudio">
            <span class="ms-2 fs-18 pt-2 fw-medium">BellaStudio</span> 
          </div>
        </mat-card-header>

        <mat-card-content class="login-form-container">
          
          <!-- OTP Entry Form -->
          <form [formGroup]="mfaForm" (ngSubmit)="onSubmit()" class="login-form" *ngIf="!showRoleSelection">
            <h2 class="auth-title fs-24 fw-medium my-0 text-center">
              Enter the verification code from your authenticator app
            </h2>
            <p class="auth-description mt-2 mb-0 fs-14 text-center">
              We're asking for this code based on your multi-factor authentication preferences.
            </p>
            
            <div class="auth-form fs-14 mt-4">
              <!-- OTP Input Fields -->
              <div class="d-flex justify-content-center pt-2 otp-inputs-container">
               <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp1"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 0)"
         (keydown)="onOtpKeydown($event, 0)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
                
                <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp2"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 1)"
         (keydown)="onOtpKeydown($event, 1)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
                
                <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp3"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 2)"
         (keydown)="onOtpKeydown($event, 2)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
                
                <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp4"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 3)"
         (keydown)="onOtpKeydown($event, 3)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
                
                <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp5"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 4)"
         (keydown)="onOtpKeydown($event, 4)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
                
               <mat-form-field appearance="outline" class="full-width auth-form-field w-100 otp-field">
  <input #otpInput
         matInput
         formControlName="otp6"
         type="text"
         inputmode="numeric"
         maxlength="1"
         (input)="onOtpInput($event, 5)"
         (keydown)="onOtpKeydown($event, 5)"
         (paste)="onOtpPaste($event)"
         autocomplete="off">
</mat-form-field>
              </div>

              <!-- Submit Button -->
              <div class="form-actions">
                <button 
                  type="submit" 
                  class="login-button auth-btn fs-14 fw-semibold"
                  [disabled]="mfaForm.invalid || isLoading">
                  <div class="button-content d-flex align-items-center justify-content-center">
                    <mat-spinner diameter="20" *ngIf="isLoading" class="me-2"></mat-spinner>
                    <span *ngIf="!isLoading">Verify Code</span>
                    <span *ngIf="isLoading">Verifying...</span>
                  </div>
                </button>
              </div>
            </div>
          </form>

          <!-- ✅ Role Selection UI -->
          <div class="role-selection-container" *ngIf="showRoleSelection">
            <h2 class="auth-title fs-24 fw-medium my-0 text-center">
              Select Your Role
            </h2>
            <p class="auth-description mt-2 mb-3 fs-14 text-center">
              You have access to multiple roles. Please select one to continue.
            </p>

            <!-- Role Cards -->
            <div class="role-cards-wrapper">
              <div 
                *ngFor="let role of availableRoles"
                class="role-card"
                [class.selected]="selectedRole?.accessBundleId === role.accessBundleId"
                [class.disabled]="isRoleConfirming"
                (click)="!isRoleConfirming && onRoleSelect(role)">
                
                <div class="role-card-content">
                  <div class="role-icon-wrapper">
                    <mat-icon class="role-icon">{{ getRoleIcon(role.bundleName) }}</mat-icon>
                  </div>
                  
                  <div class="role-info">
                    <h3 class="role-name fs-16 fw-semibold">
                      {{ getRoleDisplayName(role.bundleName) }}
                    </h3>
                    <p class="role-description fs-12">
                      {{ getRoleDescription(role.bundleName) }}
                    </p>
                  </div>

                  <!-- Selection Indicator -->
                  <div class="role-selection-indicator" *ngIf="selectedRole?.accessBundleId === role.accessBundleId">
                    <mat-icon>check_circle</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ UPDATED: Confirm Button with Loading State -->
            <div class="role-action-wrapper mt-4">
              <button 
                type="button"
                class="role-confirm-btn auth-btn fs-14 fw-semibold"
                [disabled]="!selectedRole || isRoleConfirming"
                (click)="confirmRoleSelection()">
                <div class="button-content d-flex align-items-center justify-content-center">
                  <mat-spinner diameter="20" *ngIf="isRoleConfirming" class="me-2"></mat-spinner>
                  <span *ngIf="!isRoleConfirming">
                    Continue as {{ selectedRole ? getRoleDisplayName(selectedRole.bundleName) : 'Selected Role' }}
                  </span>
                  <span *ngIf="isRoleConfirming">Processing...</span>
                </div>
              </button>
            </div>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
    
    <!-- Footer Links -->
    <div class="d-flex justify-content-center mt-auto mb-0 navi-link">
      <a class="fs-12">Terms of Service</a>
      <a  class="fs-12">Privacy Policy</a>
      <a  class="fs-12">Cookie Policy</a>
    </div>
  </div>
</div>
